"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _NewIndividual_title_accessor_storage, _NewIndividual_firstName_accessor_storage, _NewIndividual_middleName_accessor_storage, _NewIndividual_lastName_accessor_storage, _NewIndividual_suffix_accessor_storage, _NewIndividual_gender_accessor_storage, _NewIndividual_race_accessor_storage, _NewIndividual_dob_accessor_storage, _NewIndividual_age_accessor_storage, _NewIndividual_ssn_accessor_storage, _NewIndividual_titleList_accessor_storage, _NewIndividual_suffixesList_accessor_storage, _NewIndividual_genderList_accessor_storage, _NewIndividual_raceList_accessor_storage, _NewIndividual_triggerTask_accessor_storage;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewIndividual = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const new_individual_styles_1 = require("./new-individual-styles");
const math_util_1 = require("@app/util/math-util");
const lookup_client_1 = require("@app/client/lookup-client");
const task_1 = require("@lit/task");
const individual_details_util_1 = require("@app/util/individual-details-util");
let NewIndividual = class NewIndividual extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        _NewIndividual_title_accessor_storage.set(this, '');
        _NewIndividual_firstName_accessor_storage.set(this, '');
        _NewIndividual_middleName_accessor_storage.set(this, '');
        _NewIndividual_lastName_accessor_storage.set(this, '');
        _NewIndividual_suffix_accessor_storage.set(this, '');
        _NewIndividual_gender_accessor_storage.set(this, '');
        _NewIndividual_race_accessor_storage.set(this, '');
        _NewIndividual_dob_accessor_storage.set(this, '');
        _NewIndividual_age_accessor_storage.set(this, '');
        _NewIndividual_ssn_accessor_storage.set(this, '');
        _NewIndividual_titleList_accessor_storage.set(this, []);
        _NewIndividual_suffixesList_accessor_storage.set(this, []);
        _NewIndividual_genderList_accessor_storage.set(this, []);
        _NewIndividual_raceList_accessor_storage.set(this, []);
        _NewIndividual_triggerTask_accessor_storage.set(this, false);
        Object.defineProperty(this, "getLookupData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new task_1.Task(this, {
                task: async () => {
                    const lookUpClient = new lookup_client_1.LookupClient();
                    const [titles, suffixes, genders, races] = await Promise.all([
                        lookUpClient.getTitleList(),
                        lookUpClient.getSuffixesList(),
                        lookUpClient.getGenderList(),
                        lookUpClient.getRaceList(),
                    ]);
                    this.titleList = titles;
                    this.suffixesList = suffixes;
                    this.genderList = genders;
                    this.raceList = races;
                    this.requestUpdate();
                },
            })
        });
    }
    get title() { return __classPrivateFieldGet(this, _NewIndividual_title_accessor_storage, "f"); }
    set title(value) { __classPrivateFieldSet(this, _NewIndividual_title_accessor_storage, value, "f"); }
    get firstName() { return __classPrivateFieldGet(this, _NewIndividual_firstName_accessor_storage, "f"); }
    set firstName(value) { __classPrivateFieldSet(this, _NewIndividual_firstName_accessor_storage, value, "f"); }
    get middleName() { return __classPrivateFieldGet(this, _NewIndividual_middleName_accessor_storage, "f"); }
    set middleName(value) { __classPrivateFieldSet(this, _NewIndividual_middleName_accessor_storage, value, "f"); }
    get lastName() { return __classPrivateFieldGet(this, _NewIndividual_lastName_accessor_storage, "f"); }
    set lastName(value) { __classPrivateFieldSet(this, _NewIndividual_lastName_accessor_storage, value, "f"); }
    get suffix() { return __classPrivateFieldGet(this, _NewIndividual_suffix_accessor_storage, "f"); }
    set suffix(value) { __classPrivateFieldSet(this, _NewIndividual_suffix_accessor_storage, value, "f"); }
    get gender() { return __classPrivateFieldGet(this, _NewIndividual_gender_accessor_storage, "f"); }
    set gender(value) { __classPrivateFieldSet(this, _NewIndividual_gender_accessor_storage, value, "f"); }
    get race() { return __classPrivateFieldGet(this, _NewIndividual_race_accessor_storage, "f"); }
    set race(value) { __classPrivateFieldSet(this, _NewIndividual_race_accessor_storage, value, "f"); }
    get dob() { return __classPrivateFieldGet(this, _NewIndividual_dob_accessor_storage, "f"); }
    set dob(value) { __classPrivateFieldSet(this, _NewIndividual_dob_accessor_storage, value, "f"); }
    get age() { return __classPrivateFieldGet(this, _NewIndividual_age_accessor_storage, "f"); }
    set age(value) { __classPrivateFieldSet(this, _NewIndividual_age_accessor_storage, value, "f"); }
    get ssn() { return __classPrivateFieldGet(this, _NewIndividual_ssn_accessor_storage, "f"); }
    set ssn(value) { __classPrivateFieldSet(this, _NewIndividual_ssn_accessor_storage, value, "f"); }
    get titleList() { return __classPrivateFieldGet(this, _NewIndividual_titleList_accessor_storage, "f"); }
    set titleList(value) { __classPrivateFieldSet(this, _NewIndividual_titleList_accessor_storage, value, "f"); }
    get suffixesList() { return __classPrivateFieldGet(this, _NewIndividual_suffixesList_accessor_storage, "f"); }
    set suffixesList(value) { __classPrivateFieldSet(this, _NewIndividual_suffixesList_accessor_storage, value, "f"); }
    get genderList() { return __classPrivateFieldGet(this, _NewIndividual_genderList_accessor_storage, "f"); }
    set genderList(value) { __classPrivateFieldSet(this, _NewIndividual_genderList_accessor_storage, value, "f"); }
    get raceList() { return __classPrivateFieldGet(this, _NewIndividual_raceList_accessor_storage, "f"); }
    set raceList(value) { __classPrivateFieldSet(this, _NewIndividual_raceList_accessor_storage, value, "f"); }
    get triggerTask() { return __classPrivateFieldGet(this, _NewIndividual_triggerTask_accessor_storage, "f"); }
    set triggerTask(value) { __classPrivateFieldSet(this, _NewIndividual_triggerTask_accessor_storage, value, "f"); }
    connectedCallback() {
        super.connectedCallback();
        if (this.triggerTask) {
            this.getLookupData.run();
        }
    }
    handleTitleChange(event) {
        this.title = event.detail;
        this.requestUpdate();
        this.sendNewIndividual();
    }
    handleFirstNameChange(event) {
        const input = event.target;
        this.firstName = input.value;
        this.requestUpdate();
        this.sendNewIndividual();
    }
    handleMiddleNameChange(event) {
        const input = event.target;
        this.middleName = input.value;
        this.requestUpdate();
        this.sendNewIndividual();
    }
    handleLastNameChange(event) {
        const input = event.target;
        this.lastName = input.value;
        this.requestUpdate();
        this.sendNewIndividual();
    }
    handleSuffixChange(event) {
        this.suffix = event.detail;
        this.requestUpdate();
        this.sendNewIndividual();
    }
    handleGenderChange(event) {
        this.gender = event.detail;
        this.requestUpdate();
        this.sendNewIndividual();
    }
    handleRaceChange(event) {
        this.race = event.detail;
        this.requestUpdate();
        this.sendNewIndividual();
    }
    handleDobChange(event) {
        const input = event.target;
        this.dob = input.value;
        this.age = math_util_1.MathUtil.getAge(this.dob).toString();
        this.requestUpdate();
        this.sendNewIndividual();
    }
    handleAgeChange(event) {
        const input = event.target;
        this.age = input.value;
        this.requestUpdate();
        this.sendNewIndividual();
    }
    handleSsnChange(event) {
        const input = event.target;
        const value = input.value.replace(/\D/g, '').slice(0, 9);
        this.ssn = value.replace(/(\d{3})(\d{2})(\d{0,4})/, (_, p1, p2, p3) => {
            return `${p1}-${p2}${p3 ? '-' + p3 : ''}`;
        });
        this.requestUpdate();
        this.sendNewIndividual();
    }
    sendNewIndividual() {
        const sendNewIndividual = new CustomEvent('sendNewIndividual', {
            detail: {
                title: this.title,
                firstName: this.firstName,
                middleName: this.middleName,
                lastName: this.lastName,
                suffix: this.suffix,
                gender: this.gender,
                race: this.race,
                dob: this.dob,
                age: this.age,
                ssn: this.ssn,
            },
            bubbles: true,
            composed: true,
        });
        this.dispatchEvent(sendNewIndividual);
        this.requestUpdate();
    }
    render() {
        return (0, lit_1.html) `
      <forge-label class="individual-title">New Individual:</forge-label>
      <div class="new-individual-space-item">
        <sup-lookup-select
          .lookupList=${this.titleList}
          .label=${'Title'}
          @onLookupSelectChangeEvent=${this.handleTitleChange}
          .selectValue=${this.title}
        ></sup-lookup-select>
      </div>
      <div class="new-individual-row-item new-individual-space-item">
        <forge-text-field
          theme=${this.firstName !== '' ? 'default' : 'error'}
          required=${!this.firstName}
          show-clear="true"
        >
          <forge-label>First name</forge-label>
          <input
            type="text"
            @input=${this.handleFirstNameChange}
            autocomplete="given-name"
            .value=${this.firstName}
            aria-label="First name"
          />
        </forge-text-field>
        <forge-text-field show-clear="true">
          <forge-label>Middle name</forge-label>
          <input
            type="text"
            @input=${this.handleMiddleNameChange}
            autocomplete="additional-name"
            .value=${this.middleName}
            aria-label="Middle name"
          />
        </forge-text-field>
        <forge-text-field
          theme=${this.lastName !== '' ? 'default' : 'error'}
          required=${!this.lastName}
          show-clear="true"
        >
          <forge-label>Last name</forge-label>
          <input
            type="text"
            @input=${this.handleLastNameChange}
            autocomplete="family-name"
            .value=${this.lastName}
            aria-label="Last name"
          />
        </forge-text-field>
      </div>
      <div class="new-individual-row-item new-individual-space-item">
        <sup-lookup-select
          .lookupList=${this.suffixesList}
          .label=${'Suffix'}
          @onLookupSelectChangeEvent=${this.handleSuffixChange}
          .selectValue=${this.suffix}
        ></sup-lookup-select>
        <sup-lookup-select
          .lookupList=${this.genderList}
          .label=${'Gender'}
          @onLookupSelectChangeEvent=${this.handleGenderChange}
          .selectValue=${this.gender}
          .required=${!this.gender}
          .theme=${this.gender ? 'default' : 'error'}
        ></sup-lookup-select>
        <sup-lookup-select
          .lookupList=${this.raceList}
          .label=${'Race'}
          @onLookupSelectChangeEvent=${this.handleRaceChange}
          .selectValue=${this.race}
        ></sup-lookup-select>
      </div>
      <div class="new-individual-row-item new-individual-space-item">
        <forge-date-picker>
          <forge-text-field theme=${this.dob !== '' ? 'default' : 'error'} required=${!this.dob}>
            <label for="dob-picker">DOB</label>
            <input type="text" id="dob-picker" @input=${this.handleDobChange} autocomplete="off" .value=${this.dob} />
          </forge-text-field>
        </forge-date-picker>
        <forge-text-field theme=${this.age !== '' ? 'default' : 'error'} required=${!this.age}>
          <forge-label>Age</forge-label>
          <input type="text" @input=${this.handleAgeChange} autocomplete="off" .value=${this.age} aria-label="Age" />
        </forge-text-field>
      </div>
      <forge-text-field class="new-individual-space-item" show-clear="true">
        <forge-label>Social security number</forge-label>
        <input
          type="text"
          pattern="\\d{3}-\\d{2}-\\d{4}"
          placeholder="___-__-____"
          @input=${this.handleSsnChange}
          autocomplete="off"
          .value=${individual_details_util_1.IndividualDetailsUtil.getFormatSnn(this.ssn)}
          aria-label="Social security number"
        />
      </forge-text-field>
    `;
    }
};
exports.NewIndividual = NewIndividual;
_NewIndividual_title_accessor_storage = new WeakMap();
_NewIndividual_firstName_accessor_storage = new WeakMap();
_NewIndividual_middleName_accessor_storage = new WeakMap();
_NewIndividual_lastName_accessor_storage = new WeakMap();
_NewIndividual_suffix_accessor_storage = new WeakMap();
_NewIndividual_gender_accessor_storage = new WeakMap();
_NewIndividual_race_accessor_storage = new WeakMap();
_NewIndividual_dob_accessor_storage = new WeakMap();
_NewIndividual_age_accessor_storage = new WeakMap();
_NewIndividual_ssn_accessor_storage = new WeakMap();
_NewIndividual_titleList_accessor_storage = new WeakMap();
_NewIndividual_suffixesList_accessor_storage = new WeakMap();
_NewIndividual_genderList_accessor_storage = new WeakMap();
_NewIndividual_raceList_accessor_storage = new WeakMap();
_NewIndividual_triggerTask_accessor_storage = new WeakMap();
Object.defineProperty(NewIndividual, "styles", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: [new_individual_styles_1.newIndividualStyles]
});
__decorate([
    (0, decorators_js_1.property)({ type: String })
], NewIndividual.prototype, "title", null);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], NewIndividual.prototype, "firstName", null);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], NewIndividual.prototype, "middleName", null);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], NewIndividual.prototype, "lastName", null);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], NewIndividual.prototype, "suffix", null);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], NewIndividual.prototype, "gender", null);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], NewIndividual.prototype, "race", null);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], NewIndividual.prototype, "dob", null);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], NewIndividual.prototype, "age", null);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], NewIndividual.prototype, "ssn", null);
__decorate([
    (0, decorators_js_1.property)({ type: Array })
], NewIndividual.prototype, "titleList", null);
__decorate([
    (0, decorators_js_1.property)({ type: Array })
], NewIndividual.prototype, "suffixesList", null);
__decorate([
    (0, decorators_js_1.property)({ type: Array })
], NewIndividual.prototype, "genderList", null);
__decorate([
    (0, decorators_js_1.property)({ type: Array })
], NewIndividual.prototype, "raceList", null);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], NewIndividual.prototype, "triggerTask", null);
exports.NewIndividual = NewIndividual = __decorate([
    (0, decorators_js_1.customElement)('sup-new-individual')
], NewIndividual);
